import { render, staticRenderFns } from "./InsightCreate.vue?vue&type=template&id=5897fc8a&scoped=true"
import script from "./InsightCreate.vue?vue&type=script&lang=js"
export * from "./InsightCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897fc8a",
  null
  
)

export default component.exports